import requests from "./httpService";



const PurchasebillServices = {
  getpurchaseBill: async (body) => {
    return requests.post(`/purchaseBill/list/`, body);
  },

  addBill: async (id, body) => {
    return requests.put(`purchaseBill/add/${id}`, body);
  },

  checkRate: async (id, body) => {
    return requests.post(`/purchaseBill/checkRate/${id}`, body);
  },

  updateverifyStatus: async (id, body) => {
    return requests.put(`/purchaseBill/verify/${id}`, body);
  },

  updateapproveStatus: async (id, body) => {
    return requests.put(`purchaseBill/approve/${id}`, body);
  },

  updateBill: async (id, body) => {
    return requests.put(`purchaseBill/update/${id}`, body);
  },
};

export default PurchasebillServices;
